import React, { useEffect, useMemo, useState } from 'react';
import InformationComponent from './InformationComponent';
import ExpandablePanel from './components/ExpandablePanel';
import FilterChipGroup from './components/FilterChipGroup';
import DiagnosticsFixedColumnTable from './components/DiagnosticsFixedColumnTable';

const CWD_COLUMNS = ['customer_id', 'rfid', 'datetime_ist', 'search_key', 'status', 'cs_log', 'log_key'];
const CSLF_COLUMNS = ['id', 'log_file_name', 'log_time_ist', 'log_type', 'log', 'created_at_ist'];

const ShowInfo = (props) => {
  const { csInformation, csLogCustomers, csLogData, csDiagnostics } = props;
  const [filterMode, setFilterMode] = useState(null);
  const [searchValuesCwd, setSearchValuesCwd] = useState({});
  const [searchValuesCslf, setSearchValuesCslf] = useState({});
  const [cwdSearchValue, setCwdSearchValue] = useState('');
  const [cslfSearchValue, setCslfSearchValue] = useState('');

  const customerIds = useMemo(
    () =>
      csLogCustomers?.length > 0
        ? Array.from(new Set(csLogCustomers.filter((item) => item.customer_id !== '').map((item) => item.customer_id)))
        : [],
    [csLogCustomers]
  );
  const rfIds = useMemo(
    () =>
      csLogCustomers?.length > 0
        ? Array.from(new Set(csLogCustomers.filter((item) => item.rfid !== '').map((item) => item.rfid)))
        : [],
    [csLogCustomers]
  );

  useEffect(() => {
    setFilterMode(null);
    setCwdSearchValue('');
    setCslfSearchValue('');
    setSearchValuesCwd({});
    setSearchValuesCslf({});
  }, [csLogCustomers]);

  const customerWiseData = useMemo(() => {
    if (!csLogCustomers?.length) return [];
    if (!filterMode) return csLogCustomers;
    if (filterMode.type === 'customer_id') {
      return csLogCustomers.filter((item) => item.customer_id === filterMode.value);
    }
    return csLogCustomers.filter((item) => item.rfid === filterMode.value);
  }, [csLogCustomers, filterMode]);

  const selectedCustomerId = filterMode?.type === 'customer_id' ? filterMode.value : null;
  const selectedRfid = filterMode?.type === 'rfid' ? filterMode.value : null;

  const handleSearchChangeCwd = (e, key) => {
    setSearchValuesCwd((prev) => ({
      ...prev,
      [key]: e.target.value.toLowerCase(),
    }));
  };

  const handleSearchChangeCslf = (e, key) => {
    setSearchValuesCslf((prev) => ({
      ...prev,
      [key]: e.target.value.toLowerCase(),
    }));
  };

  const chipHeaderActions = (
    <span className="cs-row-count">
      {customerIds.length} IDs / {rfIds.length} RFIDs
    </span>
  );

  return (
    <>
      <div className="row align-items-stretch">
        <div className="col-lg-8">
          <InformationComponent csInformation={csInformation} />
        </div>
        <div className="col-lg-4">
          <ExpandablePanel
            title="CUSTOMER IDs &amp; RFIDs"
            compactHeight={220}
            fixedHeight={220}
            headerActions={chipHeaderActions}
            showClear={true}
            onClear={() => setFilterMode(null)}
          >
            <div className="row g-2 h-100 p-2">
              <div className="col-6">
                <FilterChipGroup
                  title="CUSTOMER IDs"
                  items={customerIds}
                  selectedId={selectedCustomerId}
                  onSelect={(id) => setFilterMode({ type: 'customer_id', value: id })}
                />
              </div>
              <div className="col-6">
                <FilterChipGroup
                  title="RFIDs"
                  items={rfIds}
                  selectedId={selectedRfid}
                  onSelect={(id) => setFilterMode({ type: 'rfid', value: id })}
                />
              </div>
            </div>
          </ExpandablePanel>
        </div>
      </div>
      <div className="row g-3 mt-1">
        <div className="col-lg-6">
          <DiagnosticsFixedColumnTable
            title="CUSTOMER WISE DATA"
            columns={CWD_COLUMNS}
            rows={customerWiseData}
            searchValues={searchValuesCwd}
            onColumnFilterChange={handleSearchChangeCwd}
            globalSearchValue={cwdSearchValue}
            onGlobalSearchChange={(e) => setCwdSearchValue(e.target.value)}
            tableId="cwd"
            exportTableKey="customer-wise-data"
            csDiagnostics={csDiagnostics}
            allExportRows={csLogCustomers}
            fixedHeight={420}
          />
        </div>
        <div className="col-lg-6">
          <DiagnosticsFixedColumnTable
            title="CHARGING STATION LOG FILE"
            columns={CSLF_COLUMNS}
            rows={csLogData}
            searchValues={searchValuesCslf}
            onColumnFilterChange={handleSearchChangeCslf}
            globalSearchValue={cslfSearchValue}
            onGlobalSearchChange={(e) => setCslfSearchValue(e.target.value)}
            tableId="cslf"
            emptyCell=""
            exportTableKey="charging-station-log-file"
            csDiagnostics={csDiagnostics}
            allExportRows={csLogData}
            fixedHeight={420}
          />
        </div>
      </div>
    </>
  );
};

export default ShowInfo;
